import { useMemo } from 'react';

const useNewsAggregators = (articles) => {
  // Group articles by publisher
  const publishers = useMemo(() => {
    return articles.reduce((acc, article) => {
      const publisherName = article.publisher?.name || 'Unknown';
      if (!acc[publisherName]) acc[publisherName] = [];
      acc[publisherName].push(article);
      return acc;
    }, {});
  }, [articles]);

  // Group articles by symbol
  const groupedBySymbols = useMemo(() => {
    return articles.reduce((acc, article) => {
      if (article.metadata.symbols) {
        article.metadata.symbols.forEach((symbol) => {
          const upperSymbol = symbol.toUpperCase(); // Ensure all symbols are uppercase
          if (!acc[upperSymbol]) acc[upperSymbol] = [];
          acc[upperSymbol].push(article);
        });
      }
      return acc;
    }, {});
  }, [articles]);

  // Filter articles based on provided criteria
  const filterArticles = (criteria) => {
    return articles.filter((article) => {
      // Check for publisher filter if it exists
      if (criteria.publisher.length > 0 && !criteria.publisher.includes(article.publisher?.name)) {
        return false;
      }
      // Check for sentiment filter if it exists
      if (criteria.sentiment) {
        const sentimentData = article.insights?.find((insight) => insight.sentiment);
        if (sentimentData?.sentiment !== criteria.sentiment) {
          return false;
        }
      }
      // Check for symbol filter if it exists
      if (criteria.symbol.length > 0) {
        const articleSymbols = article.metadata.symbols?.map(symbol => symbol.toUpperCase()) || [];
        if (!criteria.symbol.some((symbol) => articleSymbols.includes(symbol.toUpperCase()))) {
          return false;
        }
      }
      return true;
    });
  };

  return {
    publishers,
    groupedBySymbols,
    filterArticles,
  };
};

export default useNewsAggregators;
